import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Carrier onboarding" hint="MC/DOT validation queue." /> }
